export default __webpack_public_path__ + "static/funders-neu-c2eb91a60b073af0552c9cd857d6387b.png";